// First we need to import axios.js
import axios from "axios";
// Next we make an 'instance' of it
const instance = axios.create({
  // baseURL: "http://localhost/iranwushufed/api/davari/",
  baseURL: "https://iranwushufed.ir/api/davari/",
});

export default instance;
